"use client";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../core/factory/factory.mjs";
import { ModalBaseTitle } from "../ModalBase/ModalBaseTitle.mjs";
import { useDrawerContext } from "./Drawer.context.mjs";
import Drawer_module_default from "./Drawer.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Drawer/DrawerTitle.tsx
const DrawerTitle = factory((_props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("DrawerTitle", null, _props);
	return /* @__PURE__ */ jsx(ModalBaseTitle, {
		...useDrawerContext().getStyles("title", {
			classNames,
			style,
			styles,
			className
		}),
		...others
	});
});
DrawerTitle.classes = Drawer_module_default;
DrawerTitle.displayName = "@mantine/core/DrawerTitle";
//#endregion
export { DrawerTitle };

//# sourceMappingURL=DrawerTitle.mjs.map